//import react
import React, {Component} from 'react';
//import admin-on-rest lib resources
import { Admin, Resource, Delete } from 'admin-on-rest';
//import custom auth & rest client
import authClient from './authClient';
import restClient from './restClient';
import Menu from './Menu';

import translations from './i18n';

//import Material UI
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  cyan500, grey100, grey300, grey400, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';

//App sections : Dashboard
import { Dashboard } from './dashboard';
import { AdsList, AdsEdit, AdsCreate } from './admin_ads/Ads';

import { CloudhintsdomainList, CloudhintsdomainCreate, CloudhintsdomainEdit } from './cloudhints_domains/Cloudhintsdomains';
import { PlanFieldEdit, PlanFieldCreate } from './cloudhints_domains/Planfield';
import { CustomersList, CustomersCreate, CustomersEdit } from './customers/Customers';
import { OutgoinglinksList, OutgoinglinksListDeleted, OutgoinglinksCreate, OutgoinglinksEdit } from './customers/Outgoinglinks';
import { SiteclickList, SiteclickEdit } from './siteclicks/Siteclicks';
import { IpblacklistList, IpblacklistEdit, IpblacklistCreate } from './siteclicks/Ipblacklist';
import { UseragentBlacklistList, UseragentBlacklistEdit, UseragentBlacklistCreate } from './siteclicks/UseragentBlacklist';
import { SiteGroupedReportList } from './siteclicks/SiteGroupedReport';
import { CustomerGroupedReportList } from './siteclicks/CustomerGroupedReport';
import { GcrGroupedReportList } from './siteclicks/GcrGroupedReportList';
import { MonthGroupedReportList } from './siteclicks/MonthGroupedReportList';
import { ReviewList } from './review/ReviewList.js';

import { BidhistoryList } from './bidhistory/Bidhistory';
import { AdminlogList } from './adminlog/Adminlog';

import CogIcon from 'material-ui/svg-icons/content/create';
import routes from './routes';
import Login from './login';

//import authAddonSaga from './saga/authAddonSaga.js'

//Custom theme https://github.com/mui-org/material-ui/blob/master/src/styles/getMuiTheme.js
/*
* MAIN BUTTONS:  raisedButton: { textTransform: 'none',primaryColor:'#284263' }
* BUTTONS RIGHT TOP DETAIL PAGES: flatButton: { textTransform: 'none', primaryColor:'#284263', color: '#284263', backgroundColor: '#fd9512', background: '#fd9512'  },
* APPBAR: appBar: { color: '#284263' }, 
*/

//snackbar color (shonotifciations) kan zijn: niks (kleur wordt error, rood), warning (kleur wordt oranje accent1color), confirm (kleur wordt blauw primary1color)

const CloudhintsTheme = {
    spacing: spacing,
    fontFamily: 'Roboto, sans-serif',
    palette: {
      primary1Color: '#284263',
	  pickerHeaderColor : '#284263',
      primary2Color: '#284263',
      primary3Color: grey400,
      accent1Color: '#fd9512',
      accent2Color: grey100,
      accent3Color: grey500,
      textColor: darkBlack,
      alternateTextColor: white,
      canvasColor: white,
      borderColor: grey300,
      disabledColor: fade(darkBlack, 0.3),
      pickerHeaderColor: cyan500,
      clockCircleColor: fade(darkBlack, 0.07),
      shadowColor: fullBlack,
    },
	datePicker: {
		headerColor: '#284263',	
	},
	card: {	 borderColor: '#fd9512' },
	button: { margin: '0' },
	raisedButton: { textTransform: 'none',primaryColor:'#fd9512', margin: '0', spacing: '0' },
	flatButton: { textColor:'#fd9512', primaryTextColor:'#fd9512',  textTransform: 'none' },
	snackbar: {
      textColor: '#fff',
      backgroundColor: '#284263',
      actionColor: '#fff',
    },
	tabs: {
      backgroundColor: '#f3f3f3',
      textColor: '#284263',
      selectedTextColor: '#284263',
	  borderColor: '#284263',
    },
	inkBar: {
      backgroundColor: '#284263',
    },
};


class App extends Component {
    render() {
        return (
            <Admin
				loginPage={Login}
				theme={getMuiTheme(CloudhintsTheme)}
                title="Cloudhints - Admin portal"
				customRoutes={routes}
                restClient={restClient}			
                authClient={authClient}  
				dashboard={Dashboard}
                messages={translations}
                menu={Menu}
				locale='nl'
				>	
			   <Resource name="admin/ad" options={{label:'Alle advertenties'}} list={AdsList} edit={AdsEdit} create={AdsCreate} remove={Delete} />
			   <Resource name="admin/cloudhintsdomains" options={{label:'Cloudhints Sites'}} list={CloudhintsdomainList} edit={CloudhintsdomainEdit} create={CloudhintsdomainCreate} remove={Delete} />
			   <Resource name="admin/customers" options={{label:'Customers (users)'}} list={CustomersList} edit={CustomersEdit} create={CustomersCreate} remove={Delete} />
			   <Resource name="admin/outgoinglink" options={{label:'Klanten links'}} list={OutgoinglinksList} edit={OutgoinglinksEdit} create={OutgoinglinksCreate} remove={Delete} />
			   <Resource name="admin/outgoinglinkdeleted" options={{label:'Klanten links (deleted)'}} list={OutgoinglinksListDeleted} edit={OutgoinglinksEdit} create={OutgoinglinksCreate} remove={Delete} />
			   <Resource name="admin/bidhistory" options={{label:'Bieding geschiedenis'}} list={BidhistoryList} />
			   <Resource name="admin/siteclick" list={SiteclickList} edit={SiteclickEdit} remove={Delete} />
			   <Resource name="admin/siteclick_blacklisted" list={SiteclickList} edit={SiteclickEdit} remove={Delete} />
			   <Resource name="admin/siteclick_blacklisted_startswith" list={SiteclickList} edit={SiteclickEdit} remove={Delete} />
			   <Resource name="admin/siteclick_blacklisted_ai" list={SiteclickList} edit={SiteclickEdit} remove={Delete} />
			   <Resource name="admin/siteclick_filtered_doubles" list={SiteclickList} edit={SiteclickEdit} remove={Delete} />
			   <Resource name="admin/clicks_report_sitegrouped" list={SiteGroupedReportList} />
			   <Resource name="admin/clicks_report_customergrouped" list={CustomerGroupedReportList} />
			   <Resource name="admin/clicks_report_gcrgrouped" list={GcrGroupedReportList} />	
			   <Resource name="admin/clicks_report_monthgrouped" list={MonthGroupedReportList} />				   		   
			   <Resource name="admin/ipblacklist" list={IpblacklistList} edit={IpblacklistEdit} create={IpblacklistCreate} remove={Delete} />
			   <Resource name="admin/useragent_blacklist" options={{label:'User-agent blacklist'}} list={UseragentBlacklistList} edit={UseragentBlacklistEdit} create={UseragentBlacklistCreate} remove={Delete} />
			   <Resource name="public/lasthundred" list={ReviewList} />
			   <Resource name="admin/adminlog" list={AdminlogList} remove={Delete} />
			   <Resource name="admin/planfield" edit={PlanFieldEdit} create={PlanFieldCreate} remove={Delete} />
            </Admin>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js